

// Minimal Mobile Cart JavaScript - Always Prevent Page Jumping
(function() {
  let originalScrollPosition = 0;
  let isScrollLocked = false;
  
  function isMobile() {
    return window.innerWidth <= 768;
  }
  
  // Check if cart has items
  function cartHasItems() {
    const cartItems = document.querySelector('.cart__items[data-count]');
    if (cartItems) {
      const count = parseInt(cartItems.getAttribute('data-count') || '0');
      return count > 0;
    }
    
    const itemElements = document.querySelectorAll('.cart__items .cart__item, .cart-item');
    return itemElements.length > 0;
  }
  
  // Add or remove cart-has-items class
  function updateCartState() {
    const cartDrawer = document.querySelector('#HeaderCart') || document.querySelector('.site-header__cart');
    const hasItems = cartHasItems();
    
    if (cartDrawer) {
      if (hasItems) {
        cartDrawer.classList.add('cart-has-items');
        document.body.classList.add('cart-has-items');
      } else {
        cartDrawer.classList.remove('cart-has-items');
        document.body.classList.remove('cart-has-items');
      }
    }
    
    return hasItems;
  }
  
  // ALWAYS lock scroll when cart opens - prevents page jumping
  function lockMobileScrolling() {
    if (!isMobile() || isScrollLocked) return;
    
    // Store current scroll position BEFORE any CSS changes
    originalScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    
    // Apply scroll lock smoothly
    document.body.style.position = 'fixed';
    document.body.style.top = `-${originalScrollPosition}px`;
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    
    isScrollLocked = true;
  }
  
  function unlockMobileScrolling() {
    if (!isMobile() || !isScrollLocked) return;
    
    // Store the scroll position before unlocking
    const scrollTop = originalScrollPosition;
    
    // Remove scroll lock styles
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    
    // Smooth scroll restoration
    requestAnimationFrame(() => {
      if (scrollTop > 0) {
        window.scrollTo({
          top: scrollTop,
          left: 0,
          behavior: 'instant'
        });
      }
    });
    
    isScrollLocked = false;
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    
    // Initial cart state update
    updateCartState();
    
    // Watch for cart content changes
    const cartObserver = new MutationObserver(function(mutations) {
      let shouldUpdate = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.target.classList.contains('cart__items') || 
            mutation.target.querySelector('.cart__items') ||
            mutation.attributeName === 'data-count') {
          shouldUpdate = true;
        }
      });
      
      if (shouldUpdate) {
        setTimeout(updateCartState, 50);
      }
    });
    
    const cartContainer = document.querySelector('#HeaderCart') || document.querySelector('.site-header__cart');
    if (cartContainer) {
      cartObserver.observe(cartContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-count', 'class']
      });
    }
    
    // Watch for cart open class changes
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target;
          
          if (target === document.documentElement || target === document.body) {
            if (target.classList.contains('cart-open')) {
              // ALWAYS lock scroll when cart opens (prevents jumping)
              updateCartState();
              lockMobileScrolling(); // ✅ No condition - always lock
            } else {
              unlockMobileScrolling();
            }
          }
        }
      });
    });
    
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });
    
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
    
    // Alternative event listeners
    document.addEventListener('CartDrawer:open', function() {
      updateCartState();
      lockMobileScrolling(); // ✅ Always lock
    });
    
    document.addEventListener('cart:close', unlockMobileScrolling);
    
    document.addEventListener('cart:updated', function() {
      setTimeout(updateCartState, 100);
    });
    
    // Handle window resize
    window.addEventListener('resize', function() {
      const cartDrawer = document.querySelector('#HeaderCart') || document.querySelector('.site-header__cart');
      const isCartOpen = cartDrawer && cartDrawer.classList.contains('is-active');
      
      if (isCartOpen) {
        updateCartState();
        if (isMobile()) {
          lockMobileScrolling();
        } else {
          unlockMobileScrolling();
        }
      }
    });
    
    // Cleanup on page unload
    window.addEventListener('beforeunload', function() {
      if (isScrollLocked) {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overflow = '';
        isScrollLocked = false;
      }
    });
    
  });
  
})();

